import { checkGate } from '@eventbrite/statsig';
import { BoostTrial, Trial } from '../types';
import * as CoreTrialsClient from './CoreTrialsClient';
import * as TonedenTrialsClient from './TonedenTrialsClient';

// https://console.statsig.com/7n3hq8N8FgwqPLIkQ9P62X/gates/boost_trial_service_gate
const GATE_NAME = 'boost_trial_service_gate';

export const getBoostTrial = async (
    activeOrganizationId?: string,
): Promise<BoostTrial | Trial> => {
    if (checkGate(GATE_NAME)) {
        return TonedenTrialsClient.getBoostTrial();
    }

    if (!activeOrganizationId) {
        throw new Error('[getBoostTrial]: Organization ID is not provided.');
    }

    let response = null;

    const trials = await CoreTrialsClient.getTrials(activeOrganizationId);

    if (trials && !!trials.length) {
        const trialObject = trials.find((trial) => trial.package_id === 0);

        if (trialObject) {
            response = trialObject;
        }
    }

    return response;
};

export const startBoostTrial = async (
    trialVersion: string,
    activeOrganizationId?: string,
) => {
    if (checkGate(GATE_NAME)) {
        return TonedenTrialsClient.startBoostTrial(trialVersion);
    }

    if (!activeOrganizationId) {
        throw new Error('[startBoostTrial]: Organization ID is not provided.');
    }

    return await CoreTrialsClient.startTrial(activeOrganizationId);
};
